import React from 'react';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonPrimary } from '../../../../utils/Button';
import { InputFieldSearch } from '../../../../utils/InputField';
import { ApiLogsAllFilesDeleteOpe } from '../LogFilesListOperation';

function LogFilesPageHeader({ handleReload, p, onChangeHandler }) {
    const { setMessage, setConfirm, setTemplateLoading } = useTemplate();

    const handleDeleteAllLog = () => {
        setConfirm({
            text: 'Are you sure you want to delete all logs?',
            textAction: 'Yes',
            clickAction: () => {
                setTemplateLoading(true);
                ApiLogsAllFilesDeleteOpe()
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setTemplateLoading(false);
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setTemplateLoading(false);
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };
    return (
        <div className="client_page_header w-full mb-7 flex flex-row justify-between items-center">
            <div className="client_page_header_left_col flex-1 flex items-center gap-x-5">
                <InputFieldSearch
                    name="q"
                    formData={p}
                    onChange={onChangeHandler}
                    placeholder="Search..."
                    className="w-64"
                />
            </div>
            <div className="client_page_header_right_col flex items-center gap-x-2">
                <ButtonPrimary title="Delete All" onClick={() => handleDeleteAllLog()} />
                <ReloadButton onClick={handleReload} width="w-10" height="h-10" />
            </div>
        </div>
    );
}

export default LogFilesPageHeader;
